<div class="upper-part d-flex">
    <div class="line-icon">
      <img src="../../../assets/images/bottom_sheet_rectangle.svg" alt="Line Icon" />
    </div>
    <div class="close-button" (click)="closedialog()">
      <img src="../../../../../assets/images/crossIconDarkTheme.svg" alt="Close" />
    </div>
</div>